import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LandingPageBlock } from '../../../models/cms-models';

@Component({
  selector: 'cms-landing-page-references-block-editor',
  imports: [CommonModule, FormsModule],
  templateUrl: './landing-page-references-block-editor.html',
  styleUrl: './landing-page-block-editor-fields.css',
})
export class LandingPageReferencesBlockEditorComponent {
  @Input({ required: true }) block!: LandingPageBlock;
  @Output() blockChange = new EventEmitter<Partial<LandingPageBlock>>();

  updateReference(index: number, key: 'label' | 'url', value: string): void {
    const referenceLinks = this.block.referenceLinks.map((reference, referenceIndex) =>
      referenceIndex === index ? { ...reference, [key]: value } : reference,
    );

    this.blockChange.emit({ referenceLinks });
  }

  addReference(): void {
    this.blockChange.emit({
      referenceLinks: [...this.block.referenceLinks, { label: '', url: '' }],
    });
  }

  removeReference(index: number): void {
    this.blockChange.emit({
      referenceLinks: this.block.referenceLinks.filter((_, referenceIndex) => referenceIndex !== index),
    });
  }
}
